import React from "react";
import PropTypes from 'prop-types';

const Triangle = props => (
  <svg width={props.width} height={props.height} className={props.className} viewBox="0 0 8 10">
    <path fill="#F7256B" fillRule="evenodd"
      d="M4.46666667,43.7333922 L8.46666667,49.0667255 L8.46666667,49.0667255 C8.79803752,49.5085533 8.70849447,50.1353547 8.26666667,50.4667255 C8.0935705,50.5965476 7.88303688,50.6667255 7.66666667,50.6667255 L-0.333333333,50.6667255 L-0.333333333,50.6667255 C-0.885618083,50.6667255 -1.33333333,50.2190103 -1.33333333,49.6667255 C-1.33333333,49.4503553 -1.26315546,49.2398217 -1.13333333,49.0667255 L2.86666667,43.7333922 L2.86666667,43.7333922 C3.19803752,43.2915644 3.82483887,43.2020213 4.26666667,43.5333922 C4.34247233,43.5902464 4.40981242,43.6575865 4.46666667,43.7333922 Z"
      transform="rotate(90 24.667 26)"/>
  </svg>
);

Triangle.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  fill: PropTypes.string,
  ref: PropTypes.function,
}

Triangle.defaultProps = {
  width: 8,
  height: 10,
  className: "",
  fill: "#F7256B",
  ref: () => {},
}

export default Triangle;



// WEBPACK FOOTER //
// ./src/components/svgs/Triangle.js